import React from 'react'
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import { useReportBuilderContext } from '../ReportBuilderContext'
import type { ReportBuilderModel } from '../fields'

const MODEL_LABELS: Record<ReportBuilderModel, string> = {
  position: 'Position',
  distribution: 'Distribution',
  candidate: 'Candidate'
}

const ModelSelector: React.FC = () => {
  const { model, setModel } = useReportBuilderContext()
  return (
    <UncontrolledDropdown size='sm'>
      <DropdownToggle caret color='outline-secondary'>{MODEL_LABELS[model]}</DropdownToggle>
      <DropdownMenu>
        {(Object.keys(MODEL_LABELS) as ReportBuilderModel[]).map(m => (
          <DropdownItem key={m} active={model === m} onClick={() => setModel(m)}>
            {MODEL_LABELS[m]}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default ModelSelector
